"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessageStyled = exports.DialogStyled = exports.DialogPageActions = exports.DialogContentStyled = exports.DialogActionsStyled = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const DialogStyled = exports.DialogStyled = (0, _mui.styled)(_components.Dialog, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['zIndex'])
})(({
  theme,
  zIndex
}) => ({
  zIndex,
  [`.${_mui.paperClasses.root}`]: {
    rowGap: theme.spacing(3)
  },
  [`.${_components.dialogClasses.header}`]: {
    padding: theme.spacing(4, 3, 0)
  },
  [`.${_components.dialogClasses.content}`]: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'inherit',
    padding: theme.spacing(0, 3, 4),
    overflow: 'hidden'
  },
  [theme.breakpoints.up('sm')]: {
    [`.${_mui.paperClasses.root}`]: {
      rowGap: theme.spacing(6)
    },
    [`.${_components.dialogClasses.header}`]: {
      padding: theme.spacing(8, 6, 0)
    },
    [`.${_components.dialogClasses.content}`]: {
      padding: theme.spacing(0, 6, 8)
    }
  }
}));
const DialogContentStyled = exports.DialogContentStyled = (0, _mui.styled)(_mui.DialogContent)(({
  theme
}) => ({
  padding: theme.spacing(0, 1, 0, 0)
}));
const DialogActionsStyled = exports.DialogActionsStyled = (0, _mui.styled)(_mui.Stack)(({
  theme
}) => ({
  gap: theme.spacing(3, 6),
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    flexFlow: 'row-reverse',
    justifyContent: 'space-between'
  }
}));
const DialogPageActions = exports.DialogPageActions = (0, _mui.styled)(_mui.Stack)(({
  theme
}) => ({
  alignSelf: 'stretch',
  alignItems: 'inherit',
  gap: 'inherit',
  [theme.breakpoints.up('md')]: {
    flexFlow: 'row'
  }
}));
const ErrorMessageStyled = exports.ErrorMessageStyled = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.error.main
}));
